import { Typography } from "@mui/material";
import { getCurrency } from "src/utils/currencies";
import { fDecimalNumber } from "src/utils/formatNumber";

import { Position } from "../hooks/useGetPositionRows";

export default function Value({ value, currency }: Position) {
	return (
		<Typography variant='subtitle2'>{`${fDecimalNumber(value)} ${getCurrency(
			currency
		)}`}</Typography>
	);
}
